import { useLazyQuery, useQuery } from "@apollo/client";
import { CUSTOMER_ADDRESS } from "../customer-address.queries";
import {
  CustomerAddressQuery,
  CustomerAddressQueryVariables,
} from "../../../__generated__/CustomerAddressQuery";

export const useCustomerAddress = (id: number) => {
  return useQuery<CustomerAddressQuery, CustomerAddressQueryVariables>(CUSTOMER_ADDRESS, {
    variables: { id },
  });
};

export const useLazyCustomerAddress = () => {
  return useLazyQuery<CustomerAddressQuery, CustomerAddressQueryVariables>(CUSTOMER_ADDRESS);
};
